import {
  Card,
  Heading,
  Anchor,
  Grid,
  ExpandableSection,
  Divider,
} from '@enterprise-ui/canvas-ui-react';
import { EnterpriseIcon, RedoIcon } from '@enterprise-ui/icons';
import { Link as ReactLink } from 'react-router-dom';
import './styles/cardStyles.scss';
import { convertDecimalToFeet } from '../utils/helpers';

export const DeviceDetailsCard = ({
  firmwareVersion,
  locationID,
  macAddress,
  hostName,
  status,
  friendlyName,
  deviceType,
  readerHeightInput,
  readerHeight,
  leftWidth,
  rightWidth,
  zoneExtension,
  distanceToDoorInput,
  zoneExtensionSign,
  innerWidth,
}) => {
  return (
    <Card
      elevation={0}
      className="customTextPosition"
      data-testid="deviceDetails"
    >
      <Heading size={5} className="customHeader">
        Device Details{' '}
      </Heading>
      <Grid.Container
        justify="center"
        align="center"
        direction="column"
        className={'hc-mt-normal'}
      >
        <p className="hc-mb-min customDevice">
          <strong>Device Type: </strong> {deviceType}
        </p>
        <p className="hc-mb-min customDevice">
          <strong>Friendly Name: </strong> {friendlyName}
        </p>
        <p className="hc-mb-min customDevice">
          <strong>Location ID: </strong> {locationID}
        </p>
        <p className="hc-mb-min customDevice">
          <strong>MAC Address: </strong> {macAddress}
        </p>
        <p className="hc-mb-min customDevice">
          <strong>Hostname: </strong> {hostName}
        </p>
        <p className="hc-mb-min customDevice">
          <strong>Firmware Version: </strong> {firmwareVersion}
        </p>
      </Grid.Container>
      {deviceType === 'atr7000' && (
        <ExpandableSection className="hc-mt-expanded hc-bg-grey06">
          <h4 className="hc-ta-center">Device Configs</h4>
          <ExpandableSection.Content className="hc-pb-expanded">
            <Grid.Container
              justify="center"
              align="center"
              direction={'column'}
            >
              <Divider className="hc-mb-normal" />
              <p className="hc-mb-min customDevice ">
                <strong>Reader Height Input: </strong>{' '}
                {readerHeightInput
                  ? convertDecimalToFeet(readerHeightInput)
                  : 'N/A'}
              </p>
              <p className="hc-mb-min customDevice">
                <strong>Left Width Input: </strong>{' '}
                {leftWidth ? convertDecimalToFeet(leftWidth) : 'N/A'}
              </p>
              <p className="hc-mb-min customDevice">
                <strong>Right Width Input: </strong>{' '}
                {rightWidth ? convertDecimalToFeet(rightWidth) : 'N/A'}
              </p>
              <p className="hc-mb-min customDevice">
                <strong>Distance To Door Input: </strong>{' '}
                {distanceToDoorInput
                  ? convertDecimalToFeet(distanceToDoorInput)
                  : 'N/A'}
              </p>
              <p className="hc-mb-min customDevice">
                <strong>Zone Extension Sign: </strong> {zoneExtensionSign}
              </p>
              <p className="hc-mb-min customDevice">
                <strong>Reader Height: </strong>{' '}
                {readerHeight ? convertDecimalToFeet(readerHeight) : 'N/A'}
              </p>
              <p className="hc-mb-min customDevice">
                <strong>Inner Zone Width: </strong>{' '}
                {innerWidth ? convertDecimalToFeet(innerWidth) : 'N/A'}
              </p>
              <p className="hc-mb-min customDevice">
                <strong>Zone Extension: </strong>{' '}
                {zoneExtension ? convertDecimalToFeet(zoneExtension) : 'N/A'}
              </p>
            </Grid.Container>
          </ExpandableSection.Content>
        </ExpandableSection>
      )}

      {status === 'Started' && (
        <Anchor
          to="/status"
          className="iot-link"
          as={ReactLink}
          padding-left="7em"
        >
          <EnterpriseIcon icon={RedoIcon} />
          Review Device Details
        </Anchor>
      )}
    </Card>
  );
};
